import { useEffect, useState } from 'react';
import './style.css';

declare var _errorKey:any;
declare var _siteSettings: any;
declare function Translate(key: string): string;

const ErrorPage = () => {
    
  var htmlElements;    
  const [messageElements,setMessageElements] = useState<string[]>([]);
  
  useEffect(() => { 
    var errorDesc = Translate("N_General_Error_" + _errorKey) !== '' ? Translate("N_General_Error_" + _errorKey) : Translate('N_General_Error_X509_MUST_RESTART_BROWSER');
    if (errorDesc.includes("*^link")){
        var msgArr: string[] = errorDesc.split("*");               
        var msgObjArrTmp= [{isLink:false,linkHref:"",text:""}];  

        for (let index = 0; index < msgArr.length; ) {                
            if(msgArr[index] !== ""){
                if(msgArr[index].startsWith("^")){                                                                         
                    var linkName = msgArr[index].replace("^","");
                    msgObjArrTmp.push({
                                        isLink: true,
                                        linkHref: getEnvUrl(linkName),
                                        text: msgArr[index + 1]
                                    });                       
                    index = index + 2;               
                }
                else{                        
                    msgObjArrTmp.push({
                                        isLink: false,
                                        linkHref: "",
                                        text: msgArr[index]
                                    });                        
                    index = index + 1; 
                } 
            } 
            else{
                index = index + 1; 
            }          
        }

        htmlElements = msgObjArrTmp.map((item,indx) => {
            if(item.isLink){
                return (<a href={item.linkHref} key={indx}>{item.text}</a>);
            }
            else{
                return (<span key={indx}>{item.text}</span>);
            }
        });
        
        setMessageElements(htmlElements);                                    
    }
    else{
        setMessageElements([errorDesc]);
    }
    
  },[]);

  const getEnvUrl = (linkTag:string) =>{
      var targetUrl = Translate("*" + linkTag + "*");
      var targetEnvUrl="";

      switch (targetUrl) {
          case "https://account.gov.il/sspr/public/newuser":
              targetEnvUrl = _siteSettings.signupLink;
              break;
          case "https://account.gov.il/sspr/public/forgottenpassword":
              targetEnvUrl = _siteSettings.forgottenPasswordLink;
              break;
      
          default:
              targetEnvUrl = _siteSettings.signupLink;
              break;
      }

      return targetEnvUrl;
  };

  
  return(       
    <div className='ErrorPage'>       
      <div className='ErrorPage__description'>{messageElements}</div>
    </div>    
  );
};
export default ErrorPage;

